// The few income units most responsible for the current partner balance.
//
// A PARTIAL LIST, and built to read as one: no total and no foot, the remainder stated
// as its own line ("ועוד 4 יחידות"), and a link to the settlement screen, where the full
// rows do sum to the balance. The eye adds up whatever it is given, so a foot here would
// read as a breakdown that does not work.
import { useNavigate } from 'react-router-dom';
import he from '../../i18n/he';
import Money from '../../components/Money';
import Button from '../../components/Button';

const t = he.settlements.unit;

export default function BalanceTopUnits({ top }) {
  const navigate = useNavigate();
  if (!top || top.units.length === 0) return null;

  return (
    <div className="dash-top-units">
      <div className="dash-subhead">{he.dashboard.balanceTopUnits}</div>
      {top.units.map((u) => (
        <div key={u.unit} className="dash-line">
          <span>
            <span className={`badge ${u.kind === 'retainer' ? 'blue' : 'gray'}`}>
              {u.kind === 'retainer' ? t.retainer : t.job}
            </span>{' '}
            {u.title || t.unnamed}
            {u.clientName && <span className="muted"> · {u.clientName}</span>}
          </span>
          <Money value={u.net} />
        </div>
      ))}
      {top.more.count > 0 && (
        <div className="dash-line">
          <span className="muted">{he.dashboard.balanceMoreUnits(top.more.count)}</span>
          <Money value={top.more.net} className="muted" />
        </div>
      )}
      <Button variant="subtle" small onClick={() => navigate('/settlements')}>
        {he.dashboard.balanceFullBreakdown}
      </Button>
    </div>
  );
}
